import { OverlayModule } from '@angular/cdk/overlay';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, Injectable, NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule } from '@ngx-translate/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import 'hammerjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutConfigService, SplashScreenService } from './core/_base/layout';
import { RollbarErrorHandler, rollbarFactory, RollbarService } from './core/_base/layout/services/rollbar.service';
import { API_ENDPOINT } from './core/_constants/endpoints';
import { disabledServiceWorkerUrls } from './core/_constants/special-urls';
import { metaReducers, reducers } from './core/_reducers';
import { CoreModule } from './core/core.module';
import { PartialsModule } from './views/partials/partials.module';
import { TitleCasePipe } from '@angular/common';

const API_LAYOUT = API_ENDPOINT + 'config';
// Declare VodaPay miniapp module
declare var my: any;

// Partials

@Injectable({
  providedIn: 'root'
})
export class AppConfig {
  config_json: any;

  constructor(private httpClient: HttpClient) {
  }

  init(): Promise<AppConfig | any> {
    return new Promise((r) => {
      this.httpClient
        .get<any>(API_LAYOUT + '/get/' + window.location.hostname)
        .toPromise()
        .then((data: any) => {
          if (data['config_json']) {
            localStorage.removeItem('layoutConfig');
            localStorage.setItem('layoutConfig', JSON.stringify(data['config_json']));
          }
          Object.assign(this, data);
          r(this);
        })
        .catch(err => {
         
          r({})
        });
    });
  }
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        PartialsModule,
        CoreModule,
        OverlayModule,
        StoreModule.forRoot(reducers, { metaReducers: metaReducers }),
        EffectsModule.forRoot([]),
        StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
        StoreDevtoolsModule.instrument(),
        NgbModule,
        TranslateModule.forRoot(),
        MatProgressSpinnerModule,
        MatProgressBarModule,
        ServiceWorkerModule.register('sw-master.js', {
            enabled: environment.production && !disabledServiceWorkerUrls.includes(window.location.hostname)
        })], providers: [
        CookieService,
        SplashScreenService,
        TitleCasePipe,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerGestureConfig
        },
        LayoutConfigService,
        {
            // layout config initializer
            provide: APP_INITIALIZER,
            useFactory: AppConfigurationFactory,
            deps: [AppConfig],
            multi: true
        },
        { provide: ErrorHandler, useClass: RollbarErrorHandler },
        { provide: RollbarService, useFactory: rollbarFactory, deps: [AppConfig] },
        { provide: 'googleTagManagerId', useFactory: AppGoogleTagManagerId, deps: [AppConfig] },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}

export function AppConfigurationFactory(appConfig: AppConfig) {
  return () => appConfig.init();
}

function AppGoogleTagManagerId(appConfig: AppConfig) {
  if (isNotNullOrUndefined(appConfig.config_json.googleTagManagerId)) {
    return appConfig.config_json.googleTagManagerId;
  }
  return 'ADD_APP_ID_IN_DOMAIN_CONFIG';
}
